var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-wrapper"},[(_vm.currentCompany.logo != null)?_c('img',{staticClass:"logo",attrs:{"src":'/images/'+_vm.currentCompany.logo,"alt":_vm.currentCompany.name}}):_vm._e(),_c('div',{staticClass:"tagline"},[_vm._v(_vm._s(_vm.currentCompany.name)+" "+_vm._s(_vm.$t("logo.tagLine")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }